import { FC } from 'react';
import {
  Box,
  Button,
  Icon,
  Text,
  Heading,
  HStack,
  VStack,
} from '@chakra-ui/react';
import { Copy as ChainLink } from '../../../../assets';
import { getDataTracking } from '../../../../utils';

interface CustomUrlJumpCardProps {
  onEdit: () => void;
}

export const CustomUrlJumpCard: FC<CustomUrlJumpCardProps> = (props) => {
  const { onEdit } = props;
  const verbiage = `Customize your personal page URL to help others find your page faster and simplify your page links.`;

  return (
    <VStack spacing={6}>
      <HStack alignItems={['flex-start', 'center']}>
        <Heading fontSize={28} fontWeight="bold">
          Customize your fundraiser URL
        </Heading>

        <Box pt={[2, 0]}>
          <Icon as={ChainLink} boxSize="48px" />
        </Box>
      </HStack>

      <Text>{verbiage}</Text>

      <Button
        colorScheme="white"
        fontWeight="semibold"
        w="100%"
        onClick={() => onEdit()}
        {...getDataTracking('editUrl')}
      >
        Edit my page URL
      </Button>
    </VStack>
  );
};
